import {AxiosError} from 'axios';
import {GET_UNUSED_EXAM_LEVELS_QUERY_KEY} from '../../constants/queryKeys';
import {useCustomQuery} from '../../hooks/query';
import axiosClient from '../axiosClient';
import {GET_UNUSED_EXAM_LEVELS_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface UnusedExamLevels {
  code: string;
  description: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  year: number;
  uuid: string;
  onSuccess?: (data: any) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  enabled?: boolean;
}


export const useGetUnusedExamLevels = ({
                                         year,
                                         uuid,
                                         onSuccess,
                                         onError,
                                         enabled = true,
                                       }: Input) => {
  const getUnusedExamLevels = async () => {
    const res = await axiosClient.get<UnusedExamLevels[]>(GET_UNUSED_EXAM_LEVELS_URL(year, uuid));
    return res.data;
  };

  return useCustomQuery(
      GET_UNUSED_EXAM_LEVELS_QUERY_KEY,
      getUnusedExamLevels,
      {
        onSuccess,
        onError,
        enabled,
      },
      true,
      false
  );
};
